import { AmountType, CalculateByField, MeasureUnit } from "../api/biClient.types";

export const toAmountType = (units: { [key: string]: MeasureUnit }): AmountType => {
  if (units === undefined) return AmountType.Net;
  const unit = Object.values(units).find((unit) => unit.amountType !== undefined);
  return unit?.amountType || AmountType.Net;
};

export const toCalculateBy = (units: { [key: string]: MeasureUnit }): CalculateByField => {
  if (units === undefined) return CalculateByField.Lcy;
  const unit = Object.values(units).find((unit) => unit.calculateByField !== undefined);
  return unit?.calculateByField || CalculateByField.Lcy;
};
